// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-AutoDocExtraction-QuotesSection-QuotesSection-module__quotesToggleButton";
export { _1 as "quotesToggleButton" }
